import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import {Route, Switch, useHistory, useLocation} from "react-router-dom";
import SurveyListView from "./list";
import SurveySingleView from "./single";

const SurveyViews = () => {
    const location = useLocation();
    const history = useHistory();

    /**
     * Listens for the changes in the url and with each change:
     * Checks the url of the route, and if its /configurations, appends content to it.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.userPlatform.surveys.base, exact: true})) {
            history.replace(routes.userPlatform.surveys.list);
        }
    }, [history, location.pathname]);

    return (
        <Switch>
            <Route path={[routes.userPlatform.surveys.base, routes.userPlatform.surveys.list]} exact>
                <SurveyListView/>
            </Route>
            <Route path={routes.userPlatform.surveys.surveyPreview} exact>
                <SurveySingleView/>
            </Route>

        </Switch>
    );
}

export default SurveyViews;
